import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SelectButton } from 'primereact/selectbutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const ApplicationmasterAppstep2Page = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		fullname: yup.string().required().label($t('fullname')),
		loan_amount: yup.number().nullable().label($t('loanAmount')),
		loan_purpose: yup.string().nullable().label($t('loanPurpose')),
		eligible_loan_amount: yup.number().nullable().label($t('eligibleLoanAmount')),
		interest_rate: yup.number().nullable().label($t('interestRate')),
		tenure: yup.string().nullable().label($t('tenure')),
		processing_fee: yup.number().nullable().label($t('processingFee')),
		emi: yup.number().nullable().label($t('emi')),
		middlename: yup.string().nullable().label($t('middlename')),
		aadhar_verify: yup.string().required().label($t('aadharVerify')),
		pan_verify: yup.string().nullable().label($t('panVerify')),
		address_verify: yup.string().nullable().label($t('addressVerify')),
		bank_statement_verify: yup.string().nullable().label($t('bankStatementVerify')),
		average_bank_balance: yup.number().nullable().label($t('averageBankBalance')),
		credit_verify: yup.string().nullable().label($t('creditVerify')),
		credit_schore: yup.number().nullable().label($t('creditSchore')),
		credit_eligible: yup.string().nullable().label($t('creditEligible')),
		overall_status: yup.string().nullable().label($t('overallStatus')),
		ecs_authorized: yup.string().nullable().label($t('ecsAuthorized')),
		userid: yup.number().nullable().label($t('userid')),
		app_date: yup.string().nullable().label($t('appDate'))
	});
	// form default values
	const formDefaultValues = {
		fullname: '', 
		loan_amount: '', 
		loan_purpose: '', 
		eligible_loan_amount: '', 
		interest_rate: '', 
		tenure: '', 
		processing_fee: '', 
		emi: '', 
		middlename: '', 
		aadhar_verify: "(N'UnVerified", 
		pan_verify: "(N'UnVerified", 
		address_verify: "(N'UnVerified", 
		bank_statement_verify: "(N'UnVerified", 
		average_bank_balance: '', 
		credit_verify: "(N'UnVerified", 
		credit_schore: '', 
		credit_eligible: '', 
		overall_status: '', 
		ecs_authorized: '', 
		userid: '', 
		app_date: "(getdate())", 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="ApplicationmasterAppstep2Page" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('applicationStep2')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('fullname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="fullname"  onChange={formik.handleChange}  value={formik.values.fullname}   label={$t('fullname')} type="text" placeholder={$t('enterFullname')}     disabled   className={inputClassName(formik?.errors?.fullname)} />
                                                <ErrorMessage name="fullname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanAmount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loan_amount"  onChange={formik.handleChange}  value={formik.values.loan_amount}   label={$t('loanAmount')} type="number" placeholder={$t('enterLoanAmount')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.loan_amount)} />
                                                <ErrorMessage name="loan_amount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanPurpose')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loan_purpose"  onChange={formik.handleChange}  value={formik.values.loan_purpose}   label={$t('loanPurpose')} type="text" placeholder={$t('enterLoanPurpose')}        className={inputClassName(formik?.errors?.loan_purpose)} />
                                                <ErrorMessage name="loan_purpose" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('eligibleLoanAmount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="eligible_loan_amount"  onChange={formik.handleChange}  value={formik.values.eligible_loan_amount}   label={$t('eligibleLoanAmount')} type="number" placeholder={$t('enterEligibleLoanAmount')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.eligible_loan_amount)} />
                                                <ErrorMessage name="eligible_loan_amount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('interestRate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="interest_rate"  onChange={formik.handleChange}  value={formik.values.interest_rate}   label={$t('interestRate')} type="number" placeholder={$t('enterInterestRate')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.interest_rate)} />
                                                <ErrorMessage name="interest_rate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('tenure')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <SelectButton name="tenure" className={inputClassName(formik?.errors?.tenure, '')} value={formik.values.tenure} onChange={formik.handleChange} options={app.menus.tenure} optionLabel="label" optionValue="value" />
                                                <ErrorMessage name="tenure" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('processingFee')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="processing_fee"  onChange={formik.handleChange}  value={formik.values.processing_fee}   label={$t('processingFee')} type="number" placeholder={$t('enterProcessingFee')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.processing_fee)} />
                                                <ErrorMessage name="processing_fee" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('emi')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="emi"  onChange={formik.handleChange}  value={formik.values.emi}   label={$t('emi')} type="number" placeholder={$t('enterEmi')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.emi)} />
                                                <ErrorMessage name="emi" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('middlename')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="middlename"  onChange={formik.handleChange}  value={formik.values.middlename}   label={$t('middlename')} type="text" placeholder={$t('enterMiddlename')}        className={inputClassName(formik?.errors?.middlename)} />
                                                <ErrorMessage name="middlename" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('aadharVerify')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="aadhar_verify"  onChange={formik.handleChange}  value={formik.values.aadhar_verify}   label={$t('aadharVerify')} type="text" placeholder={$t('enterAadharVerify')}        className={inputClassName(formik?.errors?.aadhar_verify)} />
                                                <ErrorMessage name="aadhar_verify" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('panVerify')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pan_verify"  onChange={formik.handleChange}  value={formik.values.pan_verify}   label={$t('panVerify')} type="text" placeholder={$t('enterPanVerify')}        className={inputClassName(formik?.errors?.pan_verify)} />
                                                <ErrorMessage name="pan_verify" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('addressVerify')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="address_verify"  onChange={formik.handleChange}  value={formik.values.address_verify}   label={$t('addressVerify')} type="text" placeholder={$t('enterAddressVerify')}        className={inputClassName(formik?.errors?.address_verify)} />
                                                <ErrorMessage name="address_verify" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('bankStatementVerify')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bank_statement_verify"  onChange={formik.handleChange}  value={formik.values.bank_statement_verify}   label={$t('bankStatementVerify')} type="text" placeholder={$t('enterBankStatementVerify')}        className={inputClassName(formik?.errors?.bank_statement_verify)} />
                                                <ErrorMessage name="bank_statement_verify" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('averageBankBalance')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="average_bank_balance"  onChange={formik.handleChange}  value={formik.values.average_bank_balance}   label={$t('averageBankBalance')} type="number" placeholder={$t('enterAverageBankBalance')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.average_bank_balance)} />
                                                <ErrorMessage name="average_bank_balance" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('creditVerify')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="credit_verify"  onChange={formik.handleChange}  value={formik.values.credit_verify}   label={$t('creditVerify')} type="text" placeholder={$t('enterCreditVerify')}        className={inputClassName(formik?.errors?.credit_verify)} />
                                                <ErrorMessage name="credit_verify" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('creditSchore')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="credit_schore"  onChange={formik.handleChange}  value={formik.values.credit_schore}   label={$t('creditSchore')} type="number" placeholder={$t('enterCreditSchore')}  min={0}  step="any"    className={inputClassName(formik?.errors?.credit_schore)} />
                                                <ErrorMessage name="credit_schore" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('creditEligible')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="credit_eligible"  onChange={formik.handleChange}  value={formik.values.credit_eligible}   label={$t('creditEligible')} type="text" placeholder={$t('enterCreditEligible')}        className={inputClassName(formik?.errors?.credit_eligible)} />
                                                <ErrorMessage name="credit_eligible" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('overallStatus')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="overall_status"  onChange={formik.handleChange}  value={formik.values.overall_status}   label={$t('overallStatus')} type="text" placeholder={$t('enterOverallStatus')}        className={inputClassName(formik?.errors?.overall_status)} />
                                                <ErrorMessage name="overall_status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('ecsAuthorized')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ecs_authorized"  onChange={formik.handleChange}  value={formik.values.ecs_authorized}   label={$t('ecsAuthorized')} type="text" placeholder={$t('enterEcsAuthorized')}        className={inputClassName(formik?.errors?.ecs_authorized)} />
                                                <ErrorMessage name="ecs_authorized" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('userid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label={$t('userid')} type="number" placeholder={$t('enterUserid')}  min={0}  step="any"    className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('appDate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="app_date" showButtonBar className={inputClassName(formik?.errors?.app_date)} dateFormat="yy-mm-dd" value={formik.values.app_date} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="app_date" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
ApplicationmasterAppstep2Page.defaultProps = {
	primaryKey: 'applicationid',
	pageName: 'applicationmaster',
	apiPath: 'applicationmaster/appstep2',
	routeName: 'applicationmasterappstep2',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default ApplicationmasterAppstep2Page;
